module.exports = __webpack_public_path__ + "static/media/proKnowledge.5f49c9c8.png";